<template>
    <template v-if="isCustomerAuthenticated && !isSaveAddressInjectDisabled">
        <div v-if="addressBookAvailable && dataAddressMode === 'details'" class="row">
            <div class="col-12">
                <button type="button" class="btn btn-primary btn-block save-shipping-address"
                    v-html="$t('forms.checkout.addtoaddressbook')" @click="saveAddress(__vue_currentForm)">
                </button>
            </div>
        </div>

        <!--! DYNAMIC FORM -->
        <DynamicFields v-else :FieldsStructure="addToAddressBookFieldStructure" :FormName="__vue_currentForm" />
        <!--! DYNAMIC FORM -->
    </template>
</template>

<script setup>
import { mapGetters, mapActions, mapMutations } from "@/store/helper/vuex";
import { computed } from 'vue'
import DynamicFields from "@/components/checkout/DynamicFields"
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { useI18n } from 'vue-i18n';

const { checkout, formFields, shippingVars, billingVars, validatedFields, currentStage, vueVariables, shippingDynamicStructure, billingDynamicStructure, lastFormData, billingLocale, shippingLocale } = mapGetters();
const { saveShippingAddress, saveBillingAddress, validateAndParse, handleClientSideFieldErrors, handleDataAddressModeOnFieldErrors } = mapActions();
const { setShippingVars, setBillingVars, updateFieldError } = mapMutations();
const { t } = useI18n();

const isCustomerAuthenticated = computed(() => { return vueVariables && vueVariables.value.hasOwnProperty('isCustomerAuthenticated') ? vueVariables.value.isCustomerAuthenticated  : true });

const pdict = checkout || mapGetters().pdict;

const isSaveAddressInjectDisabled = computed(() => { return pdict.value.isSaveAddressInjectDisabled ? true : false });

const __vue_currentForm = computed(() => { return currentStage && currentStage.value === 'shipping' ? 'shipping' : 'billing' });
const addressBookAvailable = computed(() => { return currentStage && currentStage.value === 'shipping' ? pdict.value.addressBookAvailable : pdict.value.allAddressBookAvailable });

const dataAddressMode = computed(() => { return currentStage && currentStage.value === 'shipping' ? (shippingVars.value.dataAddressMode ? shippingVars.value.dataAddressMode : null) : (billingVars.value.dataAddressMode ? billingVars.value.dataAddressMode : null) });

const selectedShippingAddressUUID = computed(() => { return shippingVars.value.selectedAddressUUID });
const selectedBillingAddressUUID = computed(() => { return billingVars.value.selectedAddressUUID });

const selectedAddress = computed(() => {
    const addresses = pdict.value[currentStage && currentStage.value === 'shipping' ? 'addresses' : 'allAddresses'];
    const selectedAddressUUID = currentStage && currentStage.value === 'shipping' ? selectedShippingAddressUUID.value : selectedBillingAddressUUID.value;
    return addresses.find(address => address.UUID === selectedAddressUUID)
});

const addToAddressBookFieldStructure = computed(() => {
    return {
        row: {
            fields: [{
                ...lastFormData.value[__vue_currentForm.value].addToAddressBook,
                name: 'addToAddressBook',
                id: 'addToAddressBook',
                formId: 'shippingAddToAddressBook',
                visible: true,
                type: 'checkbox',
                classes: 'custom-checkbox form-check-input',
                formGroupClasses: 'mb-0',
                labelLayoutClasses: 'form-check-label',
                events: {
                    input: true
                },
            }],
            class: '',
        }
    }
});

const handlePhoneNumberValidation = (formFields, formType) => {
    if (formFields.phone && formFields.phone.length > 0) {
        validateAndParse({ formType: formType, formFields: formFields });
        if (!validatedFields.value[formType].phone.valid) {
            if (document.querySelector(`.${formType}-form`).dataset.addressMode === 'customer') {
                updateFieldError({ formName: formType, fieldName: 'phone', fieldValue: t('error.message.parse.phone.profile.form') });
                handleDataAddressModeOnFieldErrors();
            }
            return false;
        }

        let phoneNumber = formFields.country === 'KR' ? validatedFields.value[formType].phone.nationalFormatted : validatedFields.value[formType].phone.nationalNumber;

        if (formType === 'shipping') {
            document.querySelector(`[name=${shippingDynamicStructure.value[shippingLocale.value].get('phone').htmlName}]`).value = phoneNumber;
        } else {
            document.querySelector(`[name=${billingDynamicStructure.value[billingLocale.value].get('phone').htmlName}]`).value = phoneNumber;
        }
        return true;
    }

    return false;
}

const saveAddress = async (formName, callBack) => {
    const hasClientFieldErrors = !await handleClientSideFieldErrors({ formName, t });
    const hasPhoneNumberError = !handlePhoneNumberValidation({ ...formFields.value[formName] }, formName);

    if (hasClientFieldErrors || hasPhoneNumberError) {
        return;
    }

    let formData = new FormData(document.querySelector(`.${formName}-form`));

    let result = {};

    switch (formName) {
        case 'shipping':
            result = await saveShippingAddress({
                formData,
                addressId: dataAddressMode.value === 'details' ? selectedAddress.value.ID : '',
                copyShippingAddressToShipment: true
            });
            break;
        case 'billing':
            result = await saveBillingAddress({
                formData,
                addressId: dataAddressMode.value === 'details' ? selectedAddress.value.ID : '',
            });
            break;
    }

    if (result.success) {

        setShippingVars({
            fieldName: 'dataAddressMode',
            fieldValue: pdict.value.addressBookAvailable ? selectedShippingAddressUUID.value ? 'customer' : 'new' : 'new'
        })

        if (formName === 'shipping') {
            oldEventBus.$emit('refreshBillingSelectedAddress');
        } else {
            setBillingVars({
                fieldName: 'dataAddressMode',
                fieldValue: pdict.value.allAddressBookAvailable ? selectedBillingAddressUUID.value ? 'customer' : 'new' : 'new'
            })
        }

        if (callBack) {
            callBack();
        }
    }
}

oldEventBus.$off('saveShippingAddressBeforeBilling');
oldEventBus.$off('saveBillingAddressBeforePayment');

oldEventBus.$on('saveShippingAddressBeforeBilling', (continueToPayment) => {
    saveAddress('shipping', continueToPayment);
});

oldEventBus.$on('saveBillingAddressBeforePayment', (confirmOrder) => {
    saveAddress('billing', confirmOrder);
});
</script>